<template>
  <!-- <div class="container" :style="{'background-image': 'url('+loginbg+')'}"> -->
  <div class="container">
    <div class="forms-container">
      <div class="img_container">
        <img src="../assets/logo.png" style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" />
      </div>
      <div class="signin-signup">
        <div style="margin-top: 10%;">
          <form action="" class="sign-in-form">
            <!-- <h2 class="title" style="color: white">推客</h2>
          <h2 class="title" style="color: white;font-size: 1.2rem;padding-left: 10%;font-weight: 300;">-梦想在脚下</h2>
           -->
            <div class="input-field">
              <van-icon :name="iconphone" />
              <input
                type="text"
                v-model="loginForm.username"
                placeholder="输入账号"
              />
            </div>
            <div class="input-field">
              <van-icon :name="iconpassword" />
              <input
                type="password"
                v-model="loginForm.password"
                placeholder="输入密码"
              />
            </div>
            <div v-show="loginForm.errorVisible" style="color: #cccccc">
              {{ loginForm.errorMsg }}
            </div>

            <div class="verify-block">
              <div class="verifyBox input-field" v-show="verifyVisible">
                <van-icon :name="iconverify"></van-icon>
                <input
                  type="text"
                  maxlength="4"
                  class="verifyInput"
                  v-model="userCode"
                  placeholder="输入验证码"
                />
                <div id="v_container" @click="btncode"></div>
              </div>
              <div style="margin-top: 2%;width: 100%;">
                <van-row type="flex" justify="space-between">
                  <van-col :span="8">
                    <van-checkbox
                      v-model="remenberPasswordchecked"
                      @change="rembpwdCheckedChange"
                      icon-size="16px"
                      style="font-size: 14px;"
                      >记住密码</van-checkbox
                    >
                  </van-col>
                  <van-col :span="8">
                    <van-button
                      plain
                      type="default"
                      @click="userRegister"
                      style="color: #3333ff;border:none;background-color: rgba(255, 255, 255, 0); "
                      >注册账号</van-button
                    >
                  </van-col>
                </van-row>
              </div>
              <button @click.prevent="xxxxVerifyCode" class="solid_login">
                登录
              </button>
              <!-- <input type="button" @click="userpwdLogin" value="登 录" class="btn solid"> 
              <slide-verify
                :l="42"
                :r="10"
                :w="310"
                :h="155"
                :imgs="images"
                slider-text="向右滑动"
                @success="userpwdLogin"
                @fail="onFail"
                @refresh="onRefresh"
              >
              </slide-verify>-->
            </div>
          </form>
        </div>
        <van-row
          type="flex" justify="space-between"
          style="width: 100%;padding: 0 3.2rem; margin-top: 5px;"
        >
          <van-col :span="8">
            <van-button
              plain
              type="default"
              @click="forgetPwd"
              style="color: #3333ff;border:none;background-color: rgba(255, 255, 255, 0);"
              >忘记密码</van-button
            >
          </van-col>
          <!-- <van-col :span="8">
            <van-button
              plain
              type="default"
              @click="changeRouter"
              style="color: #3333ff;border:none;background-color: rgba(255, 255, 255, 0); "
              >切换节点</van-button
            >
          </van-col> -->
        </van-row>
        <!--
        <form action="" class="sign-up-form">
          <h2 class="title">用户注册</h2>
          <div class="input-field">
            <i class="fa fa-user"></i>
            <input type="text" placeholder="Username">
          </div>
          <div class="input-field">
            <i class="fa fa-envelope"></i>
            <input type="text" placeholder="Email">
          </div>
          <div class="input-field">
            <i class="fa fa-lock"></i>
            <input type="password" placeholder="password">
          </div>
          <input type="button" value="注 册" class="btn solid">


        </form>
        -->
      </div>
      <!--
            <div class="panels-container">
              <div class="panel left-panel">
                <div class="content">
                  <h3>新用户注册</h3>
                  <p>B2c 商务管理系统是一个使用Spring Boot、Spring Security(JWT)、Vue开发的前后端分离的商务管理框架.</p>
                  <button class="btn transparent" id="sign-up-btn">去注册</button>
                </div>

                <img src="../assets/img/log.svg" class="image" alt="">
              </div>

              <div class="panel right-panel">
                <div class="content">
                  <h3>已经注册过？</h3>
                  <p>欢迎你注册使用B2c商务管理系统，一起创造美好生活.</p>
                  <button class="btn transparent" id="sign-in-btn">去登陆</button>
                </div>

                <img src="../assets/img/register.svg" class="image" alt="">
              </div>

      </div>
      -->
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <div class="picker-continner">
        <div class="picker-title">切换线路</div>
        <div class="picker-sub-title">
          <div class="sub-title-left">节点速度</div>
          <div class="sub-title-right">
            <span>快</span>
            <span>中</span>
            <span>慢</span>
          </div>
        </div>
        <div
          class="picker-main"
          v-for="(item, index) in allConnects"
          :key="index"
        >
          <div class="main-left">{{ item.connectLineName }}</div>
          <div class="main-right">✓</div>
        </div>
        <div
          style="width: 90%;display: inline-flex;justify-content: center;align-items: center;"
        >
          <van-button @click="confirm" block style="margin: 5px;"
            >测试</van-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { setJwtToken } from "@/lib/utils";
import { login } from "@/api/system/sys_user";
import { getAllConnectLine } from "@/api/system/sys_config";
import { MessageBox, Toast } from "mint-ui";
import * as Utils from "../lib/utils";
import { GVerify } from "../lib/GVerify";
export default {
  name: "login",
  components: {},
  data() {
    return {
      verifyCode: "",
      imgData: "", // 验证码
      userCode: "", // 用户填写的动态验证码
      verifyVisible: false,
      loginForm: {
        username: "",
        password: "",
        errorMsg: "",
        errorVisible: false,
      },
      showPicker: false,
      remenberPasswordchecked: false,
      loginbg: require("@/assets/img/bglogin.jpeg"),
      dialogVisible: false,
      images: [],
      allConnects: [],
      iconphone: require("../assets/img/mobile-phone.png"),
      iconpassword: require("../assets/img/lock.png"),
      iconverify: require("../assets/img/security.png"),
    };
  },
  mounted() {
    //const sign_in_btn = document.querySelector("#sign-in-btn");
    //const sign_up_btn = document.querySelector("#sign-up-btn");
    const container = document.querySelector(".container");

    if (!Utils.isStrEmpty(localStorage.getItem("password"))) {
      this.remenberPasswordchecked = true;
      this.loginForm.username = localStorage.getItem("username");
      this.loginForm.password = Utils.decryptPassword(
        localStorage.getItem("password")
      );
      console.log(this.loginForm);
    }
    //sign_up_btn.addEventListener('click',()=>{
    //container.classList.add("sign-up-mode");
    //})

    getAllConnectLine().then((res) => {
      console.log(res.data);
      if (res.success) {
        this.allConnects = res.data;
      }
    });

    //sign_in_btn.addEventListener('click',()=>{
    //container.classList.remove("sign-up-mode");
    //})
    this.images = this.importAll(
      require.context("../assets/sliderimgs", false, /\.(png|jpe?g|svg)$/)
    );

    this.verifyCode = new GVerify("v_container");
    this.imgData = this.verifyCode.options.code.substr(
      this.verifyCode.options.code.length - 4
    );
    this.verifyVisible = true;
  },
  methods: {
    // 获取动态验证码
    btncode() {
      this.imgData = this.verifyCode.options.code.substr(
        this.verifyCode.options.code.length - 4
      );
    },
    // 校验动态验证码
    xxxxVerifyCode() {
      var userCode = this.userCode.toLowerCase();
      var v_code = this.verifyCode.options.code
        .substr(this.verifyCode.options.code.length - 4)
        .toLowerCase();
      if (userCode === v_code) {
        //alert("duile");
        this.userpwdLogin();
      } else {
        //alert("cuole");
        this.onFail();
      }
    },
    confirm() {
      this.allConnects.forEach((item) => {
        console.log(item);
        if (Utils.checkWebsite(item.connectLineUrl)) {
          item.success = true;
        } else {
          item.success = false;
        }
      });
    },
    changeRouter() {
      this.showPicker = true;
    },
    importAll(r) {
      return r.keys().map(r);
    },
    rembpwdCheckedChange(val) {
      this.remenberPasswordchecked = val;
      if (this.remenberPasswordchecked) {
        console.log(this.loginForm);
        localStorage.setItem("username", this.loginForm.username);
        localStorage.setItem(
          "password",
          Utils.encryptPassword(this.loginForm.password)
        );
      } else {
        localStorage.removeItem("password");
        this.loginForm.password = "";
      }
    },
    userRegister() {
      if (window.location.hostname == "zb.taoxibao.fit") {
        this.$router.push({ name: "anchorregister" });
      } else {
        this.$router.push({ name: "register" });
      }
    },
    forgetPwd() {
      this.$router.push({ name: "forgetpwd" });
    },
    userpwdLogin() {
      let roleCode = "customer";
      if (
        window.location.hostname == "zb.taoxibao.fit" ||
        window.location.pathname == "/author"
      ) {
        roleCode = "anchor";
      }
      login(this.loginForm.username, this.loginForm.password, roleCode)
        .then((res) => {
          setJwtToken(res.data);
          this.$router.push({ path: "/home/uservipcenter" });
        })
        .catch((err) => {
          this.loginForm.errorMsg = err.message;
          this.loginForm.errorVisible = true;
        });
    },
    getPassword() {},
    onFail() {
      console.log("验证失败，请重新验证");
      Toast({
        message: "验证失败，请重新验证",
        position: "top",
        duration: 5000,
      });
    },
    onRefresh() {
      this.loginForm.errorMsg = "刷新失败";
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        vm.$route.query.username != null &&
        vm.$route.query.password != null
      ) {
        vm.loginForm = vm.$route.query;
        vm.userpwdLogin();
      }
    });
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* google字体库 */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body,
input {
  font-family: "Poppins", sans-serif;
}

.container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  // background: linear-gradient(
  //   115deg,
  //   rgb(103, 208, 122) 0,
  //   rgb(79, 79, 216) 100%
  // );
  background-image: url(../assets/img/loginbg.png);
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

.picker-continner {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: linear-gradient(
    115deg,
    rgb(103, 208, 122) 0,
    rgb(79, 79, 216) 100%
  );
}

.picker-title {
  width: 90%;
  text-align: center;
  padding: 10px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.picker-main {
  width: 90%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(204, 204, 204, 0.3);
  border: 0px solid grey;
  border-radius: 5px;
  margin: 5px;
  color: #fff;
  padding: 5px;
}

.picker-sub-title {
  width: 90%;
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 14px;
  color: grey;
}

.sub-title-right {
  color: #fff;
}

.sub-title-right span {
  margin: 5px;
}

.sub-title-right span:first-child::before {
  content: "1";
  background-color: green;
  color: green;
  border-radius: 46%;
  border: 1px solid #fff;
  margin-right: 2px;
  padding: 1px;
  font-size: 10px;
}

.sub-title-right span:nth-child(2)::before {
  content: "1";
  background-color: yellow;
  color: yellow;
  border-radius: 46%;
  border: 1px solid #fff;
  margin-right: 2px;
  padding: 1px;
  font-size: 10px;
}

.sub-title-right span:nth-child(3)::before {
  content: "1";
  background-color: red;
  color: red;
  border-radius: 46%;
  border: 1px solid #fff;
  margin-right: 2px;
  padding: 1px;
  font-size: 10px;
}

.container::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  /*background: linear-gradient(-45deg,#4481eb,#04befe);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  */
  z-index: 4;
  transition: 1.8s ease-in-out;
}

/deep/.van-checkbox__label {
  margin-left: 8px;
  color: #3333ff;
  line-height: 20px;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
}

.signin-signup {
  position: absolute;
  top: 58%;
  left: 50%;
  /* 作用是什么 */
  transform: translate(-50%, -50%);
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 5;
  transition: 1s 0.7s ease-in-out;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  /* 难点 */
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  /* delay防止表单提前暴露 */
  transition: 0.2s 0.7s ease-in-out;
}

form.sign-in-form {
  z-index: 2;
}

form.sign-up-form {
  z-index: 1;
  opacity: 0;
}

.title {
  font-size: 2.2rem;
  color: #444;
  margin-bottom: 10px;
}

.input-field {
  max-width: 300px;
  width: 100%;
  height: 55px;
  // background-color: #f0f0f0;
  margin: 10px 0;
  border-radius: 0px;
  display: grid;
  grid-template-columns: 8.2% 85%;
  // padding: 0 0.4rem;
  border-bottom: 1px solid #d7d0d0;
}

.input-field i {
  text-align: left;
  line-height: 55px;
  color: #3b4df1;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1rem;
  color: #6d6c6c;
}

.input-field input::placeholder {
  color: #a5a1a1;
  font-weight: 500;
}

.btn {
  width: 300px;
  height: 44px;
  border: none;
  outline: none;
  border-radius: 0px;
  cursor: pointer;
  background-color: #5995fd;
  color: #fff;
  /* 大写 */
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  /* 动画延迟 */
  transition: 0.5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.social-text {
  padding: 0.7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 40px;
  width: 40px;
  border: 1px solid #333;
  margin: 0 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 1.1rem;
  border-radius: 50%;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #44b1eb;
}

.panels-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  z-index: 7;
}

.panel .content {
  color: #fff;
  transition: 0.9s 0.6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.image {
  width: 100%;
  transition: 1.1s 0.4s ease-in-out;
}

.right-panel .content,
.right-panel .image {
  transform: translateX(800px);
}

.container.sign-up-mode:before {
  transform: translate(100%, -50%);
  right: 52%;
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

.container.sign-up-mode .signin-signup {
  left: 25%;
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

  .img_container {
    width: 64px;
    height: 64px;
    padding: 12%;
    margin: 0;
    border-radius: 105px;
    background-color: #fff;
    position: relative;
    top: 5%;
    left: 38%;
    box-shadow: 1px 4px 5px 0px rgba(97, 121, 156, 0.75);
    overflow: hidden;
  }

@media (max-width: 870px) {
  .container {
    min-height: 800px;
    height: auto;
    width: 100%;
    // background: linear-gradient(
    //   115deg,
    //   rgb(103, 208, 122) 0,
    //   rgb(79, 79, 216) 100%
    // );
    background-color: #fff;
    background-image: url(../assets/img/loginbg.png);
    background-repeat: no-repeat;
    background-size: contain;
  }

  .container:before {
    width: 100%;
    height: 100%;
    /*
    left: 30%;
    bottom: 68%;
    transform: translateX(-50%);
    right: initial;
    top: initial;
    transition: 2s ease-in-out;
     */
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    // background-color: rgba(0, 0, 0, 0.3);
    z-index: 4;
  }

  .signin-signup {
    width: 100%;
    left: 50%;
    top: 65%;
    transform: translate(-50%, -70%);
    transition: 1s 0.8s ease-in-out;
  }

  .img_container {
    width: 64px;
    height: 64px;
    padding: 12%;
    margin: 0;
    border-radius: 105px;
    background-color: #fff;
    position: relative;
    top: 5%;
    left: 38%;
    box-shadow: 1px 4px 5px 0px rgba(97, 121, 156, 0.75);
    overflow: hidden;
  }

  .panels-container {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }

  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.btn.transparent {
    width: 220px;
    height: 35px;
    font-variation-settings: 0.7rem;
  }

  .panel .content {
    padding-right: 15%;
    transition: 0.9s 0.8s ease-in-out;
  }

  .right-panel .content,
  .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 5%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 465px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }

  .container .left-panel .content,
  .container .right-panel .content {
    margin-left: 40px;
  }
}

.verify-block {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .verifyBox {
    display: inline-flex;
    height: 100%;
    align-items: center;
    max-width: 300px;
    .verifyInput {
      height: 30px;
      width: 50%;
      padding-left: 5px;
    }
  }
  .solid_login {
    width: 260px;
    border: none;
    outline: none;
    border-radius: 28px;
    cursor: pointer;
    color: #fff;
    background: linear-gradient(to right, #3333ff, #3392ff);
    /* 大写 */
    text-transform: uppercase;
    font-weight: 600;
    padding: 14px 0;
    /* 动画延迟 */
    transition: 0.5s;
    margin-top: 50px;
  }
}

::v-deep .van-row--justify-space-between {
  align-items: center;
}
</style>
